export enum PaymentIntentMetadata {
    createdByNorthstarUserGuid = "created_by_northstar_user_guid",
    createdByWaypointUserGuid = "created_by_waypoint_user_guid",
    isManualCharge = "manual_charge",
    agencyInvoiceNumber = "agency_invoice_number",
    includedFeeAmount = "included_fee_amount",
    lineItem1 = "line_item_1",
    lineItem2 = "line_item_2",
    lineItem3 = "line_item_3",
    lineItem4 = "line_item_4",
    lineItem5 = "line_item_5",
    lineItem6 = "line_item_6",

    policyId = "policy_id",
    billingPeriodIndex = "billing_period_index",
    billingPeriodStartDate = "billing_period_start_date",
    billingPeriodEndDate = "billing_period_end_date",
    billingPeriodDueDate = "billing_period_due_date",
    paymentType = "payment_type",
    amountInCents = "amount_in_cents",
}

export namespace PaymentIntentMetadata {
    export enum PaymentType {
        downPayment = "down_payment",
        premium = "premium",
        escrowDeposit = "escrow_deposit",
    }
}